import { render, staticRenderFns } from "./single-inspection-form.component.vue?vue&type=template&id=4d5fe6a4&scoped=true"
import script from "./single-inspection-form.component.ts?vue&type=script&lang=ts&external"
export * from "./single-inspection-form.component.ts?vue&type=script&lang=ts&external"
import style0 from "./single-inspection-form.component.vue?vue&type=style&index=0&id=4d5fe6a4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5fe6a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d5fe6a4')) {
      api.createRecord('4d5fe6a4', component.options)
    } else {
      api.reload('4d5fe6a4', component.options)
    }
    module.hot.accept("./single-inspection-form.component.vue?vue&type=template&id=4d5fe6a4&scoped=true", function () {
      api.rerender('4d5fe6a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shared/single-inspection-form/single-inspection-form.component.vue"
export default component.exports